import { pathMatches } from "../util/pathMatches";
import simplePageViewEventTag from "../tags/simplePageViewEventTag";
import { maXCheckoutApplicationViewEventsTag } from "../tags/maXCheckoutApplicationViewEventsTag";
function executeCustomTags() {
    var customTags = new Map();
    customTags.set("^/max/checkout/.*$", maXCheckoutApplicationViewEventsTag);
    customTags.forEach(function (tag, path) {
        if (pathMatches(document.location.pathname, path))
            tag.executeSafely();
    });
}
export var triggerPageOnLoadTags = function () {
    simplePageViewEventTag.executeSafely();
    executeCustomTags();
};
